import { FormattedMessage } from "react-intl";

/**
 * A row of mutually exclusive choices. Used wherever a preference has three values
 * and a toggle would have to lie about one of them.
 */
function Segmented<T extends string>({
  value,
  options,
  onPick,
  label,
  testId,
  className,
}: {
  value: T;
  options: readonly T[];
  onPick: (value: T) => void;
  label: (option: T) => string;
  testId: string;
  className?: string;
}) {
  return (
    <div
      className={"flex bg-tint-neutral rounded-pill p-[3px] gap-0.5 " + (className ?? "")}
      role="radiogroup"
      data-testid={testId}
    >
      {options.map((option) => (
        <button
          key={option}
          type="button"
          role="radio"
          aria-checked={value === option}
          data-testid={`${testId}-${option}`}
          onClick={() => onPick(option)}
          className={
            "flex-1 text-center px-3 py-2 rounded-pill text-card-title whitespace-nowrap " +
            (value === option
              ? "bg-tint-segment shadow-ring-segment text-accent font-medium"
              : "text-muted")
          }
        >
          <FormattedMessage id={label(option)} />
        </button>
      ))}
    </div>
  );
}

export default Segmented;
